import type { DebtData } from '@/types';
import { accountPaymentPath, coveredByAccountPayment } from './accountPayment';
import { isClearedDebt } from './debtFilters';
import { isScheduledPayment } from './paymentPlans';

export interface DebtPage {
  kind: 'payment' | 'payment_plan' | 'cleared_debt';
  path: string;
}

/**
 * The page a debt opens on — the dashboard's tap target, and the chat's button to that debt.
 * Null for an overpaid debt, which has no page of its own.
 */
export function debtPage(debt: DebtData, accountPayment: 'scheduled' | 'plan' | null): DebtPage | null {
  if (debt.currentBalance < 0) return null;
  if (isClearedDebt(debt)) return { kind: 'cleared_debt', path: `/debt/${debt.id}/cleared` };
  // Grouped with the account payment, so it opens where that payment is shown.
  if (coveredByAccountPayment(debt, accountPayment)) return { kind: accountPayment === 'plan' ? 'payment_plan' : 'payment', path: accountPaymentPath(accountPayment) };
  // A scheduled single payment is a payment in progress, shown on the payment page rather
  // than the plan-management page.
  if (debt.paymentPlan && !isScheduledPayment(debt.paymentPlan)) return { kind: 'payment_plan', path: `/payment-plan/${debt.id}` };
  return { kind: 'payment', path: `/payment/${debt.id}` };
}
